'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from "lodash";

angular.module('management.ctrls', [])
    .controller('ManagementToolsController', ManagementToolsController)
    .controller('StatusListController', StatusListController);

ManagementToolsController.$inject = ['$scope', '$state', '$compile', '$timeout', '$rootScope', '$stateParams', '$confirm', 'UserService', 'ClusterService', 'ModalService','DateRangeService', 'TaskService', 'WorkflowsService','OrdersService', '$ioAlert', 'FormService', 'ProductService'];
function ManagementToolsController ($scope, $state, $compile, $timeout, $rs, $stateParams, $confirm, UserService, ClusterService,ModalService, DateRangeService, TaskService, WorkflowsService ,OrdersService, $ioAlert, FormService, ProductService) {
    $scope.undoTaskClose = true;
    $scope.changeStatus = false;
    $scope.changeStatusorder = false;
    $scope.bulkchanges = true;
    $scope.bulkChangesObj ={};
    $scope.seltype = ["Cancel","Complete","Change Status","Throw Actions","Reset Workflow","Update User","Set Fields to Default Value", "Rollup compute"];
    $scope.selobjects = ["Clients","Orders","Line Items","Flights","Tasks"];
    $scope.selUserTypeAndObject = ["Create Order User for Orders","Submit User for Orders","Finance User for Orders","Create Order User for Line Items","Submit User for Line Items","Campaign Manager for Line Items","Clear Campaign Manager for Line Items"];
    $scope.setFieldToDefaultConditions = ["Only set empty fields","Set every field to its default regardless of value"];
    $scope.deleteTask = true;
    $scope.usersLoaded = false;
    $scope.formsLoaded = false;
    $scope.fieldsLoaded = false;
    $scope.tasksStatusArr = [];
    $scope.associatedLineItems = {};
    $scope.associatedFlights = {};
    $scope.tasksList = [];
    $scope.ordersList = [];
    $scope.formList = [];
    $scope.fieldList = [];
    $scope.isClosedTasks = true;
    $scope.taskTableLoaded = false;
    $scope.orderTableLoaded = false;
    $scope.disableBtnAction = false;
    $scope.alreadyRendered = [];
    $scope.lineItemAlreadyRendered = [];
    $scope.toggleLineItem = [];
    $scope.toggleFlight = [];
    $scope.dtLineItemOptions = [];
    $scope.dtFlightOptions = [];
    let orderStatusArr = [];
    $scope.otherOrderStatusArr = [];
    $scope.StatusArr = [];
    $scope.workflowActions = [];
    $scope.clusters = [];
    $scope.products = [];
    let lineItemStatusArr = [];
    let flightStatusArr = [];
    let clientStatusArr = [];
    const flightSystemStatuses = ['Pending Submission','Pending Creative','Pending Fulfillment','Scheduled','Live',
        'In Progress','Submitted','Running','Complete','Closed','In Review','Live Edited','Pending Billing',
        'Pending Cancellation','Cancelled'];
    const lineItemSystemStatuses = ['Pending Submission','Pending Creative','Pending Fulfillment','Live','Running',
        'Complete','Closed','Credit Hold','Rejected','Pending Approval','Live Edited','Pending Cancellation',
        'Cancelled'];  // Note: the following are considered non-system: 'Paused','Resumed','Archived','Activated'
    const orderSystemStatuses = ['Draft','Submitted','Approved','Live','Running','Complete','Closed','Live Edited','Pending Cancellation','Cancelled'];
    $scope.pageObj = {
        perPageOptions: [10, 25, 50, 100],
        maxSize: 5,
        perPage: 50,
        currentPage: 1,
        totalCount: 0,
        orderBy: 'id',
        startIndex: 1,
        endIndex: 1
    };
    $scope.$watch('pageObj.currentPage', function() {
        $scope.pageObj.startIndex =  Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
        $scope.pageObj.endIndex = Math.min(($scope.pageObj.currentPage)*$scope.pageObj.perPage);
        if ($scope.pageObj.endIndex>$scope.pageObj.totalCount) {
            $scope.pageObj.endIndex = $scope.pageObj.totalCount;
        }
    });


    var initQueueDataTableOptions = function(orderId) {
        $scope.dtLineItemOptions[orderId] = {};
        $scope.dtLineItemOptions[orderId].hasFixedHeader = false;
        $scope.dtLineItemOptions[orderId].data = $scope.associatedLineItems[orderId];
        $scope.dtLineItemOptions[orderId].columns = [
            {className: 'lineitem-details-control', label: '', sortable: false},
            {field: 'id', label: 'Line Item Id'},
            {field: 'product_name', label: 'Product Name'},
            {field: 'status_name', label: 'Status'},
            {field: 'actions', label: 'Actions', is_primary_key: true, format: 'custom'}
        ];
        $scope.dtLineItemOptions[orderId].entityName = 'line items';
        $scope.dtLineItemOptions[orderId].itemName = 'line item';
        $scope.dtLineItemOptions[orderId].iActions = 24;
        $scope.dtLineItemOptions[orderId].customRenders = {};

        let otherStatuses = '';
        _.each(lineItemStatusArr, function(status) {
            if (_.indexOf(lineItemSystemStatuses, status.name) === -1) {
                otherStatuses += '<li role="menuitem"><a class="other-status" style="color: #222222">' + status.name + '</a></li>';
            }
        });

        if (otherStatuses !== '') {
            otherStatuses =
                '<span class="dropdown" dropdown="">'
                + '<button class="btn btn-default btn-xs actions-btn dropdown-toggle" dropdown-toggle="" type="button" id="dropdownLineItemOtherStatusesMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'
                + 'Other &nbsp; <span class="caret"></span>'
                + '</button>'
                + '<ul class="dropdown-menu" role="menu" aria-labelledby="dropdownLineItemOtherStatusesMenuButton" ng-click="$event.stopPropagation()">'
                + otherStatuses
                + '</ul>'
                + '</span>';
        }

        $scope.dtLineItemOptions[orderId].customRenders['actions'] = function (data, type, full) {
            return ( '<a class="action-ps btn btn-default btn-xs actions-btn has-tooltip" title="Pending Submission">PS</a>'
                + '<a class="action-pc btn btn-default btn-xs actions-btn has-tooltip" title="Pending Creative">PC</a>'
                + '<a class="action-pf btn btn-default btn-xs actions-btn has-tooltip" title="Pending Fulfillment">PF</a>'
                + '<a class="action-live btn btn-default btn-xs actions-btn">Live</a>'
                + '<a class="action-running btn btn-default btn-xs actions-btn">Running</a>'
                + '<a class="action-complete btn btn-default btn-xs actions-btn">Complete</a>'
                + '<a class="action-closed btn btn-default btn-xs actions-btn">Closed</a>'
                + '<a class="action-ch btn btn-default btn-xs actions-btn has-tooltip" title="Credit Hold">CH</a>'
                + '<a class="action-rejected btn btn-default btn-xs actions-btn">Rejected</a>'
                + '<a class="action-pa btn btn-default btn-xs actions-btn has-tooltip" title="Pending Approval">PA</a>'
                + '<a class="action-edited btn btn-default btn-xs actions-btn">Edited</a>'
                + '<a class="action-pcn btn btn-default btn-xs actions-btn has-tooltip" title="Pending Cancellation">PCN</a>'
                + '<a class="action-cancelled btn btn-default btn-xs actions-btn">Cancelled</a>'
                + otherStatuses);
        };
        $scope.dtLineItemOptions[orderId].customRenders['caret'] = function (data, type, full) {
            return ('<a></a>');
        };
        $scope.dtLineItemOptions[orderId].fnCreatedRow = function(row, raw, id) {
            // Set the row (tr element)'s id so we can retrieve it when comes the time to display flights.
            // Note that the raw parameter is the lineItem object.
            $(row).attr('id', 'LI_TR' + raw.id);

            // Add the right caret, and the on-click function
            $(row).find('td').each(function() {
                if ($(this).hasClass('lineitem-details-control')) {
                    $(this).addClass('icomoon-caret-right');
                    if (raw.__enable_flights == '1') {
                        $(this).click(function () {
                            $scope.getLineItemFlights(raw);
                        });
                    } else {
                        $(this).addClass('selectedIconDisabled');
                    }
                }
            });

            $(row).find('a').each(function() {
                if($(this).hasClass('action-ps')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Pending Submission');
                    });
                }
                else if($(this).hasClass('action-pc')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Pending Creative');
                    });
                }
                else if($(this).hasClass('action-pf')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Pending Fulfillment');
                    });
                }
                else if($(this).hasClass('action-live')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Live');
                    });
                }
                else if($(this).hasClass('action-running')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Running');
                    });
                }
                else if($(this).hasClass('action-complete')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Complete');
                    });
                }
                else if($(this).hasClass('action-closed')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Closed');
                    });
                }
                else if($(this).hasClass('action-ch')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Credit Hold');
                    });
                }
                else if($(this).hasClass('action-rejected')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Rejected');
                    });
                }
                else if($(this).hasClass('action-pa')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Pending Approval');
                    });
                }
                else if($(this).hasClass('action-edited')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Live Edited');
                    });
                }
                else if($(this).hasClass('action-pcn')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Pending Cancellation');
                    });
                }
                else if($(this).hasClass('action-cancelled')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus( raw, orderId, 'Cancelled');
                    });
                }
                else if ($(this).hasClass('other-status')) {
                    $(this).click(function() {
                        $scope.updateLineItemStatus(raw, orderId, $(this).text());
                    });
                }
            });
            $.core.main.tooltip($(row));
        };
    };

    var initFlightDataTableOptions = function(lineItemId) {
        $scope.dtFlightOptions[lineItemId] = {};
        $scope.dtFlightOptions[lineItemId].hasFixedHeader = false;
        $scope.dtFlightOptions[lineItemId].data = $scope.associatedFlights[lineItemId];
        $scope.dtFlightOptions[lineItemId].columns = [
            {field: 'id', label: 'Flight Id'},
            {field: 'name', label: 'Flight Name'},
            {field: 'status_name', label: 'Status'},
            {field: 'actions', label: 'Actions', is_primary_key: true, format: 'custom'}
        ];
        $scope.dtFlightOptions[lineItemId].entityName = 'flights';
        $scope.dtFlightOptions[lineItemId].itemName = 'flight';
        $scope.dtFlightOptions[lineItemId].iActions = 24;
        $scope.dtFlightOptions[lineItemId].customRenders = {};

        let otherStatuses = '';
        _.each(flightStatusArr, function(status) {
            if (_.indexOf(flightSystemStatuses, status.name) === -1) {
                otherStatuses += '<li role="menuitem"><a class="other-status" style="color: #222222">' + status.name + '</a></li>';
            }
        });

        if (otherStatuses !== '') {
            otherStatuses =
                '<span class="dropdown" dropdown="">'
                + '<button class="btn btn-default btn-xs actions-btn dropdown-toggle" dropdown-toggle="" type="button" id="dropdownFlightOtherStatusesMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'
                + 'Other &nbsp; <span class="caret"></span>'
                + '</button>'
                + '<ul class="dropdown-menu" role="menu" aria-labelledby="dropdownFlightOtherStatusesMenuButton" ng-click="$event.stopPropagation()">'
                + otherStatuses
                + '</ul>'
                + '</span>';
        }

        $scope.dtFlightOptions[lineItemId].customRenders['actions'] = function (data, type, full) {
            return ( '<a class="action-ps btn btn-default btn-xs actions-btn has-tooltip" title="Pending Submission">PS</a>'
                + '<a class="action-pc btn btn-default btn-xs actions-btn has-tooltip" title="Pending Creative">PC</a>'
                + '<a class="action-pf btn btn-default btn-xs actions-btn has-tooltip" title="Pending Fulfillment">PF</a>'
                + '<a class="action-scheduled btn btn-default btn-xs actions-btn">Scheduled</a>'
                + '<a class="action-live btn btn-default btn-xs actions-btn">Live</a>'
                + '<a class="action-inprogress btn btn-default btn-xs actions-btn">In Progress</a>'
                + '<a class="action-submitted btn btn-default btn-xs actions-btn">Submitted</a>'
                + '<a class="action-running btn btn-default btn-xs actions-btn">Running</a>'
                + '<a class="action-complete btn btn-default btn-xs actions-btn">Complete</a>'
                + '<a class="action-closed btn btn-default btn-xs actions-btn">Closed</a>'
                + '<a class="action-inreview btn btn-default btn-xs actions-btn">In Review</a>'
                + '<a class="action-liveedited btn btn-default btn-xs actions-btn">Live Edited</a>'
                + '<a class="action-pb btn btn-default btn-xs actions-btn has-tooltip" title="Pending Billing">PB</a>'
                + '<a class="action-pcn btn btn-default btn-xs actions-btn has-tooltip" title="Pending Cancellation">PCN</a>'
                + '<a class="action-cancelled btn btn-default btn-xs actions-btn">Cancelled</a>'
                + otherStatuses);
        };

        $scope.dtFlightOptions[lineItemId].fnCreatedRow = function(row, raw, id) {
            $(row).find('a').each(function() {
                if ($(this).hasClass('action-ps')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Pending Submission');
                    });
                }
                else if ($(this).hasClass('action-pc')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Pending Creative');
                    });
                }
                else if ($(this).hasClass('action-pf')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Pending Fulfillment');
                    });
                }
                else if ($(this).hasClass('action-scheduled')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Scheduled');
                    });
                }
                else if ($(this).hasClass('action-live')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Live');
                    });
                }
                else if ($(this).hasClass('action-inprogress')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'In Progress');
                    });
                }
                else if ($(this).hasClass('action-submitted')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Submitted');
                    });
                }
                else if ($(this).hasClass('action-running')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Running');
                    });
                }
                else if ($(this).hasClass('action-complete')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Complete');
                    });
                }
                else if ($(this).hasClass('action-closed')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Closed');
                    });
                }
                else if ($(this).hasClass('action-inreview')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'In Review');
                    });
                }
                else if ($(this).hasClass('action-liveedited')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Live Edited');
                    });
                }
                else if ($(this).hasClass('action-pb')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Pending Billing');
                    });
                }
                else if ($(this).hasClass('action-pcn')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Pending Cancellation');
                    });
                }
                else if ($(this).hasClass('action-cancelled')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, 'Cancelled');
                    });
                }
                else if ($(this).hasClass('other-status')) {
                    $(this).click(function() {
                        $scope.updateFlightStatus(raw, lineItemId, $(this).text());
                    });
                }
            });
            $.core.main.tooltip($(row));
        };
    };

    let clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        if ($scope.changeStatus) {
            $scope.getTasksList( $scope.isClosedTasks ? 'getOpenTaskAssignments' : 'getClosedTaskAssignments');
        } else if ($scope.changeStatusorder) {
            $scope.getArchivedOrdersList();
        }
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    let getTasksStatus = function() {
        TaskService.getTasksStatus().then(function(data) {
            $scope.tasksStatusArr = data;
        }, function(error) {

        })
    };

    let getOrderStatus = function() {
        OrdersService.getOrderStatuses().then(function() {
            orderStatusArr = OrdersService.statuses;
            $scope.otherOrderStatusArr = [];
            // Determine which ones shall be displayed under the "Other" button at the end (on the far right side) of the buttons.
            _.each(orderStatusArr, function(status) {
                if (_.indexOf(orderSystemStatuses, status.name) === -1) {
                    $scope.otherOrderStatusArr.push(status);
                }
            });
        }, function(error) {
            console.log("Error loading order status list");
        })
    };

     /*
    * Handle get instance lock configuration
    */
   let getInstanceLockConfig = function() {
    FormService.getInstanceLockConfig().then(function(data) {
        if (data.instanceLocked) {
            $scope.disableBtnAction = true;
        } else {
            $scope.disableBtnAction = false;
        }

    }, function(error) {
        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
    });
    }

    let getWorkflowActions = function() {
        WorkflowsService.getWorkflowActions().then(function(success) {
            $scope.workflowActions = WorkflowsService.workflowActions;
        }, function(error) {
            console.log("Error loading workflow action list");
        });
    };

    let getLineItemStatus = function() {
        OrdersService.getLineItemStatuses().then(function(data) {
            if (data) {
                lineItemStatusArr = data;
            }
        }, function(error) {
            console.log("Error loading lineItem status list")
        });
    };

    let getFlightStatus = function() {
        OrdersService.getFlightStatuses().then(function(data) {
            if (data) {
                flightStatusArr = data;
            }
        }, function(error) {
            console.log("Error loading flight status list")
        });
    };

    let getClientStatus = function() {
        OrdersService.getClientStatuses().then(function(data) {
            if (data) {
                clientStatusArr = data;
            }
        }, function(error) {
            console.log("Error loading client status list")
        });
    };

    const getSubmitUsers = function() {
        if (!$scope.usersLoaded) {
            // No specific cluster, get all of them.
            UserService.getSubmitUsers(null).then(function () {
                $scope.userArr = UserService.users;
                $scope.usersLoaded = true;
            }, function () {
                console.log("Error getting submit user list.");
            });
        }
    };

    const getFinanceUsers = function() {
        if (!$scope.usersLoaded) {
            UserService.getAllFinanceUsers().then(function () {
                $scope.userArr = UserService.users;
                $scope.usersLoaded = true;
            }, function () {
                console.log("Error getting finance user list.");
            });
        }
    };

    const getCampaignManagers = function() {
        if (!$scope.usersLoaded) {
            // No specific cluster, get all of them.
            UserService.getCampaignManagers(null).then(function () {
                $scope.userArr = UserService.users;
                $scope.usersLoaded = true;
            }, function () {
                console.log("Error getting campaign manager list.");
            });
        }
    };

    $scope.selectType = function(){
        $scope.disabledObjects = [];
        if ($scope.bulkChangesObj.type && $scope.bulkChangesObj.type != 'Change Status') {
            $scope.disabledObjects.push('Tasks');
        }
        if ($scope.bulkChangesObj.type == 'Cancel' || $scope.bulkChangesObj.type == 'Complete') {
            $scope.disabledObjects.push('Clients');
        }
        if ($scope.bulkChangesObj.type && $scope.bulkChangesObj.type === 'Update User') {
            $scope.usersLoaded = false;
            $scope.bulkChangesObj.selUserTyp = null;
        }
        if ($scope.bulkChangesObj.type == 'Rollup compute') {
            $scope.disabledObjects.push('Tasks');
        }
    }

    $scope.findIds = function(){
            var data = {};
            //data.pixel = pixel;
            ModalService.returnModalType('findIds', data).result.then(function() {}, function(cancel) {
                console.log("cancel");
            })
    }
     $scope.restrictAlphabets = function(event){
         const e = event;
         if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0',','].indexOf(e.key) === -1) {
             e.preventDefault();
         }
    }
    $scope.saveChanges = function(bulkChangesForm) {
        if (bulkChangesForm.$valid) {
            if ($scope.bulkChangesObj.type != 'Set Fields to Default Value' && 
                $scope.bulkChangesObj.inputValues &&
                !Array.isArray($scope.bulkChangesObj.inputValues)) {
                // If we're clicking the Execute button twice in a row, inputValues will already be split into an array...
                $scope.bulkChangesObj.inputValues = $scope.bulkChangesObj.inputValues.split(/[^0-9-]+/g).filter(v => v).join(',');
                $scope.bulkChangesObj.inputValues = $scope.bulkChangesObj.inputValues.split(',');
            }
            let param = {};
            if ($scope.bulkChangesObj.type == 'Change Status') {
                if ($scope.bulkChangesObj.selObject == 'Orders') {
                    param['statusId'] = $scope.bulkChangesObj.statusId;
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkOrderStatus(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in update status');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
                    param['statusId'] = $scope.bulkChangesObj.statusId;
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkLineItemStatus(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in update Line Item status');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Flights') {
                    param['statusId'] = $scope.bulkChangesObj.statusId;
                    param['flightIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkFlightStatus(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error updating flight statuses');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Clients') {
                    param['statusId'] = $scope.bulkChangesObj.statusId;
                    param['clientIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkClientStatus(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error updating client statuses');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Tasks') {
                    param['statusId'] = $scope.bulkChangesObj.statusId;
                    param['taskAssignmentIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkTaskStatus(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in update Task status');
                    });
                }
            } else if ($scope.bulkChangesObj.type == 'Complete') {
                if ($scope.bulkChangesObj.selObject == 'Orders') {
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.completeBulkOrder(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in complete Order ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.completeBulkLineItem(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in Complete Line Item ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Flights') {
                    param['flightIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.completeBulkFlight(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error completing flights');
                    });
                }
            } else if ($scope.bulkChangesObj.type == 'Cancel') {
                if ($scope.bulkChangesObj.selObject == 'Orders') {
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.cancelBulkOrder(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in Cancel Order ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.cancelBulkLineItem(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in cancel Line Item ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Flights') {
                    param['flightIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.cancelBulkFlight(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error cancelling flights');
                    });
                }
            } else if ($scope.bulkChangesObj.type == 'Throw Actions') {
                if ($scope.bulkChangesObj.selObject == 'Orders') {
                    param['workflowActionId'] = $scope.bulkChangesObj.selAction;
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.ThrowActionOrder(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in  workflow Order ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
                    param['workflowActionId'] = $scope.bulkChangesObj.selAction;
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.ThrowActionLineItem(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in  workflow Line Item ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Flights') {
                    param['workflowActionId'] = $scope.bulkChangesObj.selAction;
                    param['flightIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.ThrowActionFlight(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error executing flight workflow actions');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Clients') {
                    param['workflowActionId'] = $scope.bulkChangesObj.selAction;
                    param['clientIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.ThrowActionClient(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error executing client workflow actions');
                    });
                }
            } else if ($scope.bulkChangesObj.type == 'Reset Workflow') {
                if ($scope.bulkChangesObj.selObject == 'Orders') {
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.resetWorkflowBulkOrder(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in reset workflow Order ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.resetWorkflowLineItem(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('error in reset workflow Line Item ');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Flights') {
                    param['flightIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.resetWorkflowFlight(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error resetting flight workflows');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Clients') {
                    param['clientIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.resetWorkflowClient(param).then(function(data) {
                        if (data) {
                            for (let i=0;i<data.messages.length;i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function(error) {
                        console.log('Error resetting client workflows');
                    });
                }
            } else if ($scope.bulkChangesObj.type == 'Update User') {
                if ($scope.bulkChangesObj.selUserTyp !== 'Clear Campaign Manager for Line Items') {
                    param['userId'] = $scope.bulkChangesObj.userId;
                }
                if ($scope.bulkChangesObj.selUserTyp === 'Create Order User for Orders') {
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkCreateOrderUserForOrders(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating orders create order user');
                    });
                } else if ($scope.bulkChangesObj.selUserTyp === 'Submit User for Orders') {
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkSubmitUserForOrders(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating orders submit user');
                    });
                } else if ($scope.bulkChangesObj.selUserTyp === 'Finance User for Orders') {
                    param['orderIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkFinanceUserForOrders(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating orders finance user');
                    });
                } else if ($scope.bulkChangesObj.selUserTyp === 'Create Order User for Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkCreateOrderUserForLineItems(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating line items create order user');
                    });
                } else if ($scope.bulkChangesObj.selUserTyp === 'Submit User for Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkSubmitUserForLineItems(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating line items submit user');
                    });
                } else if ($scope.bulkChangesObj.selUserTyp === 'Campaign Manager for Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.updateBulkCampaignManagerForLineItems(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating line items campaign manager');
                    });
                } else if ($scope.bulkChangesObj.selUserTyp === 'Clear Campaign Manager for Line Items') {
                    param['lineItemIds'] = $scope.bulkChangesObj.inputValues;
                    OrdersService.clearBulkCampaignManagerForLineItems(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function () {
                        console.log('Error clearing line items campaign manager');
                    });
                }
            } else if ($scope.bulkChangesObj.type == 'Set Fields to Default Value') {
                $confirm.open({
                    size: 'sm',
                    text: 'These '+$scope.bulkChangesObj.selObject.toLowerCase()+' field changes cannot be undone. Are you sure you want to proceed?'
                }).then(function() {
                    if ($scope.bulkChangesObj.selObject == 'Line Items') {
                        param['productId'] = $scope.bulkChangesObj.formId;
                        param['productFieldId'] = $scope.bulkChangesObj.fieldId;
                    } else {
                        param['formId'] = $scope.bulkChangesObj.formId;
                        param['formFieldId'] = $scope.bulkChangesObj.fieldId;
                    }
                    param['unconditional'] = $scope.bulkChangesObj.condition == 'Set every field to its default regardless of value';
                    param['emptyFields'] = $scope.bulkChangesObj.condition == 'Only set empty fields';
                    OrdersService.updateBulkDefaultValues(param).then(function (data) {
                        if (data && data.messages) {
                            for (let i = 0; i < data.messages.length; i++) {
                                $ioAlert.show('', data.messages[i], 'success');
                            }
                            $scope.bulkChangesObj = {};
                        } else if (data && data.errors) {
                            for (let i = 0; i < data.errors.length; i++) {
                                $ioAlert.show('', data.errors[i], 'error');
                                console.log(data.errors[i]);
                            }
                            $scope.bulkChangesObj = {};
                        }
                    }, function (error) {
                        console.log('Error updating line items campaign manager');
                    });
                }, function() {})
            } else if ($scope.bulkChangesObj.type == 'Rollup compute') {
                if ($scope.bulkChangesObj.selObject == 'Clients') {
                    const clusterIds = $scope.bulkChangesObj.clusterIds.map( cluster => cluster.id );
                    $rs.loadingInProgress = true;
                    $rs.loadertitle = "Bulk rollup clients";
                    OrdersService.bulkRollupClients(clusterIds).then(function (data) {
                        $rs.loadingInProgress = false;
                    }, function (error) {
                        console.log('Error bulk rollup clients');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Orders') {
                    const orderIds = $scope.bulkChangesObj.inputValues;
                    const clusterIds = $scope.bulkChangesObj.clusterIds?.map( cluster => cluster.id );
                    $rs.loadingInProgress = true;
                    $rs.loadertitle = "Bulk rollup orders";
                    OrdersService.bulkRollupOrders(orderIds, clusterIds).then(function (data) {
                        $rs.loadingInProgress = false;
                    }, function (error) {
                        console.log('Error bulk rollup orders');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
                    const productIds = $scope.bulkChangesObj.products.map( product => product.id );
                    $rs.loadingInProgress = true;
                    $rs.loadertitle = "Bulk rollup lineItems";
                    OrdersService.bulkRollupLineItems(productIds).then(function (data) {
                        $rs.loadingInProgress = false;
                    }, function (error) {
                        console.log('Error bulk rollup Line Items');
                    });
                } else if ($scope.bulkChangesObj.selObject == 'Flights') {
                    const productIds = $scope.bulkChangesObj.products.map( product => product.id );
                    $rs.loadingInProgress = true;
                    $rs.loadertitle = "Bulk rollup flights";
                    OrdersService.bulkRollupFlights(productIds).then(function (data) {
                        $rs.loadingInProgress = false;
                    }, function (error) {
                        console.log('Error bulk rollup Flights');
                    });
                }
            }
        } else {
            $ioAlert.show('Error!', 'Please, fill the required fields.', 'error');
        }
    };

    $scope.showInputIds = function() {
        const normal = ['Set Fields to Default Value', 'Rollup compute'].indexOf($scope.bulkChangesObj.type) == -1;
        const rollupOrders = $scope.bulkChangesObj.type == 'Rollup compute' && $scope.bulkChangesObj.selObject == 'Orders';
        const result = normal || rollupOrders
        return result;
    }

    $scope.goback = function() {
        if ($scope.backTo == "1") {
            $scope.changeStatusorder = false;
            $scope.bulkchanges = false;
            $scope.changeStatus = true;
        } else if ($scope.backTo == "0") {
            $scope.changeStatusorder = true;
            $scope.bulkchanges = false;
            $scope.changeStatus = false;
        }
    };

    $scope.selectObjectTypes = function() {
        $scope.disabledTypes = [];
        $scope.bulkChangesObj.fieldId = null;
        $scope.bulkChangesObj.formId = null;
        $scope.formList = [];
        $scope.fieldList = [];
        $scope.formsLoaded = false;
        $scope.fieldsLoaded = false;

        if ($scope.bulkChangesObj.type == 'Set Fields to Default Value') {
            fetchForms();
            return;
        }
        if ($scope.bulkChangesObj.selObject == 'Orders') {
            $scope.StatusArr = orderStatusArr;
            $scope.clusters = ClusterService.clusters.slice(1);
        } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
            $scope.StatusArr = lineItemStatusArr;
            $rs.loadingInProgress = true;
            ProductService.getAllProducts('no').then(function(data) {
                $scope.products = data;
                $rs.loadingInProgress = false;
            }, function() {
                console.log("Error getting active products list");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Flights') {
            $scope.StatusArr = flightStatusArr;
            $rs.loadingInProgress = true;
            ProductService.getAllProducts('no').then(function(data) {
                $scope.products = data;
                $rs.loadingInProgress = false;
            }, function() {
                console.log("Error getting active products list");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Tasks') {
            $scope.StatusArr = $scope.tasksStatusArr;
            $scope.disabledTypes.push('Cancel');
            $scope.disabledTypes.push('Complete');
            $scope.disabledTypes.push('Throw Actions');
            $scope.disabledTypes.push('Reset Workflow');
        } else if ($scope.bulkChangesObj.selObject == 'Clients') {
            $scope.StatusArr = clientStatusArr;
            $scope.disabledTypes.push('Cancel');
            $scope.disabledTypes.push('Complete');
            $scope.clusters = ClusterService.clusters.slice(1);
        }
    };
    const fetchForms = function() {
        $scope.bulkChangesObj.fieldId = null;
        $scope.bulkChangesObj.formId = null;
        $scope.formList = [];
        $scope.fieldList = [];
        $scope.formsLoaded = false;
        $scope.fieldsLoaded = false;
        if ($scope.bulkChangesObj.selObject == 'Orders') {
            FormService.getAllOrderForms().then(function(data) {
                $scope.formList = data;
                $scope.formsLoaded = true;
            }, function() {
                console.log("Error loading order form list");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
            ProductService.getAllProducts('no').then(function(data) {
                $scope.formList = data;
                $scope.formsLoaded = true;
                }, function() {
                console.log("Error getting active products list");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Flights') {
            FormService.getAllFlightForms().then(function(data) {
                $scope.formList = data;
                $scope.formsLoaded = true;
            }, function() {
                console.log("Error loading flight form list");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Tasks') {
            // Tasks is currently disabled, but if we ever decide to support it, we'll need this code.
            FormService.getAllTaskForms().then(function(data) {
                $scope.formList = data;
                $scope.formsLoaded = true;
            }, function() {
                console.log("Error loading task form list");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Clients') {
            FormService.getAllClientForms().then(function(data) {
                $scope.formList = data;
                $scope.formsLoaded = true;
            }, function() {
                console.log("Error loading client form list");
            });
        }
    }

    $scope.selectForm = function() {
        $scope.fieldList = [];
        $scope.fieldsLoaded = false;
        $scope.bulkChangesObj.fieldId = null;
        if ($scope.bulkChangesObj.selObject == 'Orders' || $scope.bulkChangesObj.selObject == 'Flights' ||
            $scope.bulkChangesObj.selObject == 'Tasks' || $scope.bulkChangesObj.selObject == 'Clients') {
            FormService.getFormFields($scope.bulkChangesObj.formId, null, false).then(function(data) {
                $scope.fieldList = getFieldsWithDefault(data);
                $scope.fieldsLoaded = true;
            }, function() {
                console.log("Error loading form fields");
            });
        } else if ($scope.bulkChangesObj.selObject == 'Line Items') {
            let params = {};
            params.productId = $scope.bulkChangesObj.formId;
            ProductService.getProductFields(params).then(function() {
                $scope.fieldList = getFieldsWithDefault(ProductService.productFields);
                $scope.fieldsLoaded = true;
            }, function() {
                console.log("Error loading product fields");
            });
        }
    }

    const getFieldsWithDefault = function (fieldList) {
        let fieldsWithDefault = [];
        _.each(fieldList, function(field) {
            // Make sure default values of 0 are accepted, but that for multiselect, empty array is NOT accepted.
            if ((field.default_value || field.default_value === 0) && field.default_value !== '' &&
                field.default_value !== [] && !(field.default_value == '[]' && field.input_type == 'multiselect')) {
                fieldsWithDefault.push(field);
            }
        });
        return fieldsWithDefault;
    }

    $scope.selectUserAndObjectTypes = function() {
        if ($scope.bulkChangesObj.selUserTyp === 'Create Order User for Orders' ||
            $scope.bulkChangesObj.selUserTyp === 'Create Order User for Line Items' ||
            $scope.bulkChangesObj.selUserTyp === 'Submit User for Orders' ||
            $scope.bulkChangesObj.selUserTyp === 'Submit User for Line Items') {
            $scope.usersLoaded = false;
            getSubmitUsers();
        } else if ($scope.bulkChangesObj.selUserTyp === 'Finance User for Orders') {
            $scope.usersLoaded = false;
            getFinanceUsers();
        } else if ($scope.bulkChangesObj.selUserTyp === 'Campaign Manager for Line Items') {
            $scope.usersLoaded = false;
            getCampaignManagers();
        } else if ($scope.bulkChangesObj.selUserTyp === 'Clear Campaign Manager for Line Items') {
            $scope.usersLoaded = true;
        } else {
            console.log('Error: Invalid user type and object: ' + $scope.bulkChangesObj.selUserTyp);
        }
    };

    $scope.updateTaskStatus = function(task, status) {
        var param = {
            "id": task.id
        };
        for (var i = 0, len = $scope.tasksStatusArr.length; i < len; i++) {
            if ($scope.tasksStatusArr[i].name == status) {
                param.statusId = $scope.tasksStatusArr[i].id;
                break;
            }
        }
        TaskService.updateTaskStatus(param).then(function(data) {
            if (data) {
                $ioAlert.show('', 'Task Status Updated Successfully', 'success');
                $scope.getTasksList( $scope.isClosedTasks ? 'getOpenTaskAssignments' : 'getClosedTaskAssignments');
            }
        }, function(error) {
        });
    };

    $scope.changeTaskMode = function() {
        $scope.isClosedTasks = !$scope.isClosedTasks;
        $scope.getTasksList( $scope.isClosedTasks ? 'getOpenTaskAssignments' : 'getClosedTaskAssignments');
    };

    $scope.getTasksListData = function() {
        $scope.getTasksList( $scope.isClosedTasks ? 'getOpenTaskAssignments' : 'getClosedTaskAssignments');
    };

    $scope.getTasksList = function(type) {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Admin Tools";
        var params = {
            "clusterId": ClusterService.clusterIds[0],
            page: $scope.pageObj.currentPage,
            perPage: $scope.pageObj.perPage,
            orderBy: $scope.pageObj.orderBy,
            search: $scope.pageObj.search
        };
        TaskService[type](params).then(function(data) {
            $scope.tasksList = data.taskAssignments;
            $scope.pageObj.totalCount = data.total_count;
            $scope.pageObj.currentPage = data.page;
            $scope.taskTableLoaded = true;
            $rs.loadingInProgress = false;
        }, function(error) {
            $rs.loadingInProgress = false;
        });
    };

    //Get the list of completed orders
    $scope.getArchivedOrdersList = function() {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Admin Tools";
        var params = {
            "clusterId": ClusterService.clusterIds[0],
            page: $scope.pageObj.currentPage,
            perPage: $scope.pageObj.perPage,
            orderBy: $scope.pageObj.orderBy,
            search: $scope.pageObj.search
        };
        OrdersService.getOrdersWithPagination(params).then(function(data) {
            $scope.ordersList = data.orders;
            $scope.pageObj.totalCount = data.total_count;
            $scope.pageObj.currentPage = data.page;
            $scope.orderTableLoaded = true;
            $rs.loadingInProgress = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
        });
    };

    $scope.updateOrderStatus = function(order, status) {
        var param = {
            "id": order.id
        };
        for (var i = 0, len = orderStatusArr.length; i < len; i++) {
            if (orderStatusArr[i].name == status) {
                param.statusId = orderStatusArr[i].id;
                break;
            }
        }
        OrdersService.updateOrderStatus(param).then(function(data) {
            if (data) {
                $ioAlert.show('', 'Order Status Updated Successfully', 'success');
                $scope.getArchivedOrdersList();
            }
        }, function(error) {});
    };

    $scope.getOrderLineItems = function (order, event) {
        $scope.alreadyRendered[order.id] = 0;
        let trObj = $("#TR" + order.id);
        let tdObj = trObj.find("td.details-control");
        let trHTML = '<div class="panel panel-default">' +
            '<table class="table innerTable">' +
            '<tr>' +
            '<td class="no-border">' +
            '<div class="main-content">' +
            '<div class="detail-order-table order-item-table-'+order.id+'">' +
            '</div>' +
            '</div>' +
            '</td>' +
            '</tr>' +
            '</table>' +
            '</div>';
        if ($(tdObj).hasClass('icomoon-caret-right')) {
            $(tdObj).removeClass('icomoon-caret-right');
            $(tdObj).addClass('icomoon-caret-down');
            trObj.after('<tr class="tr-line-item"><td colspan="5">'+trHTML+'</td></tr>');
            $scope.alreadyRendered[order.id]++;
            let genLineItems = function() {
                let lineItemElem = 'div.order-item-table-' + order.id;
                let tableContainer = $(trObj.parent()).find(lineItemElem);
                let safeId = parseInt(order.id, 10);
                if (isNaN(safeId)) { return; }
                let template = '<div ng-if="toggleLineItem['+safeId+']"><table legacy-datatable dt-options="dtLineItemOptions['+safeId+']"></table></div>';
                let linkFn = $compile(template);
                let content = linkFn($scope);
                tableContainer.append(content);
            };
            genLineItemTable(order, genLineItems);
        } else {
            $(tdObj).removeClass('icomoon-caret-down');
            $(tdObj).addClass('icomoon-caret-right');
            trObj.next('.tr-line-item').remove();
            $scope.alreadyRendered[order.id] = 0;
        }
    }

    $scope.getLineItemFlights = function (lineItem) {
        $scope.lineItemAlreadyRendered[lineItem.id] = 0;
        let trObj = $("#LI_TR" + lineItem.id);
        let tdObj = trObj.find("td.lineitem-details-control");
        let trHTML = '<div class="panel panel-default">' +
            '<table class="table innerTable">' +
            '<tr>' +
            '<td class="no-border">' +
            '<div class="main-content">' +
            '<div class="detail-order-table lineitem-item-table-'+lineItem.id+'">' +
            '</div>' +
            '</div>' +
            '</td>' +
            '</tr>' +
            '</table>' +
            '</div>';
        if ($(tdObj).hasClass('icomoon-caret-right')) {
            $(tdObj).removeClass('icomoon-caret-right');
            $(tdObj).addClass('icomoon-caret-down');
            trObj.after('<tr class="tr-flight"><td colspan="5">'+trHTML+'</td></tr>');
            $scope.lineItemAlreadyRendered[lineItem.id]++;
            let genFlights = function() {
                let flightElem = 'div.lineitem-item-table-' + lineItem.id;
                let tableContainer = $(trObj.parent()).find(flightElem);
                let safeId = parseInt(lineItem.id, 10);
                if (isNaN(safeId)) { return; }
                let template = '<div ng-if="toggleFlight['+safeId+']"><table legacy-datatable dt-options="dtFlightOptions['+safeId+']"></table></div>';
                let linkFn = $compile(template);
                let content = linkFn($scope);
                tableContainer.append(content);
            };
            genFlightTable(lineItem, genFlights);
        } else {
            $(tdObj).removeClass('icomoon-caret-down');
            $(tdObj).addClass('icomoon-caret-right');
            trObj.next('.tr-flight').remove();
            $scope.lineItemAlreadyRendered[lineItem.id] = 0;
        }
    }

    $scope.updateLineItemStatus = function(lineItem, orderId, status) {
        let param = {
            "id": lineItem.id
        };
        for (let i = 0, len = lineItemStatusArr.length; i < len; i++) {
            if (lineItemStatusArr[i].name == status) {
                param.statusId = lineItemStatusArr[i].id;
                break;
            }
        }
        OrdersService.updateLineItemStatus(param).then(function(data) {
            if (data) {
                $ioAlert.show('', 'Line Item Status Updated Successfully', 'success');
                for (let i = 0, len = $scope.associatedLineItems[orderId].length; i < len; i++) {
                    if ($scope.associatedLineItems[orderId][i].id == lineItem.id) {
                        $scope.associatedLineItems[orderId][i].status_name = status;
                        $timeout(function(){
                            $scope.toggleLineItem[orderId] = false;
                            $scope.$apply();
                        });
                        $timeout(function(){
                            $scope.toggleLineItem[orderId] = true;
                            $scope.$apply();
                        });
                        break;
                    }
                }
            }
        }, function(error) {});
    };

    $scope.updateFlightStatus = function(flight, lineItemId, status) {
        let param = {
            "id": flight.id
        };
        for (let i = 0, len = flightStatusArr.length; i < len; i++) {
            if (flightStatusArr[i].name == status) {
                param.statusId = flightStatusArr[i].id;
                break;
            }
        }
        OrdersService.updateFlightStatus(param).then(function(data) {
            if (data) {
                $ioAlert.show('', 'Flight Status Updated Successfully', 'success');
                for (let i = 0, len = $scope.associatedFlights[lineItemId].length; i < len; i++) {
                    if ($scope.associatedFlights[lineItemId][i].id == flight.id) {
                        $scope.associatedFlights[lineItemId][i].status_name = status;
                        $timeout(function(){
                            $scope.toggleFlight[lineItemId] = false;
                            $scope.$apply();
                        });
                        $timeout(function(){
                            $scope.toggleFlight[lineItemId] = true;
                            $scope.$apply();
                        });
                        break;
                    }
                }
            }
        }, function(error) {});
    };

    function genLineItemTable (order, genLineItems) {
        $scope.associatedLineItems[order.id] = [];
        //var clusterId = ClusterService.clusterId;
        OrdersService.getLineItems(order.id).then(function(data) {
            $scope.associatedLineItems[order.id] = data;
            initQueueDataTableOptions(order.id);
            $scope.alreadyRendered[order.id]--;
            return(order.id);
        }, function(error) {
            $ioAlert.show('Error getting line items!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }).then(function(orderId ){
            if($scope.alreadyRendered[orderId] === 0){
                genLineItems();
            }
            $scope.toggleLineItem[orderId] = true;
        });
    }

    function genFlightTable (lineItem, genFlights) {
        $scope.associatedFlights[lineItem.id] = [];
        OrdersService.getFlights(lineItem.id).then(function(data) {
            $scope.associatedFlights[lineItem.id] = data;
            // Loop over the flights and set the name attribute if not set, using flight_name instead.  This is the same
            // logic as in viewLineItem.html, so we can use either field to display the flight's name.
            _.each($scope.associatedFlights[lineItem.id], function(flight){
                if (!flight.name) {
                    flight.name = flight.flight_name;
                }
            });
            initFlightDataTableOptions(lineItem.id);
            $scope.lineItemAlreadyRendered[lineItem.id]--;
            return(lineItem.id);
        }, function(error) {
            $ioAlert.show('Error getting flights!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }).then(function(lineItemId ){
            if($scope.lineItemAlreadyRendered[lineItemId] === 0){
                genFlights();
            }
            $scope.toggleFlight[lineItemId] = true;
        });
    }

    $scope.changeStatusStateTask = function(mode){
        if(mode){
            $scope.changeStatusorder = false;
            $scope.bulkchanges = false;
            $scope.changeStatus = true;
            $scope.getTasksListData();
        } else if($scope.changeStatus){
            $scope.pageObj.currentPage = 1;
            $scope.changeStatus = false;
            $scope.getArchivedOrdersList();
        }
    };
    $scope.changeStatusStateOrder = function(mode){
        if(mode){
            $scope.changeStatus = true;
        } else {
            $scope.bulkchanges = false;
            $scope.changeStatusorder = true;
            if($scope.changeStatusorder){
                $scope.pageObj.currentPage = 1;
                $scope.changeStatus = false;
                $scope.getArchivedOrdersList();
            }
        }
    };
    $scope.showStatusListFunc = function() {
        $state.go('statusList');
    };

    $scope.goToBulkChange = function() {
        $scope.backTo = "";
        if ($scope.changeStatus == true) {
            $scope.backTo = "1"
        }
        if ($scope.changeStatusorder == true) {
            $scope.backTo = "0"
        }
        $scope.changeStatus = false;
        $scope.changeStatusorder = false;
        $scope.bulkchanges = true;
    }

    let init = function() {
        ClusterService.initCluster($rs.userRole);
        DateRangeService.init();
        getTasksStatus();
        getOrderStatus();
        getWorkflowActions();
        getLineItemStatus();
        getFlightStatus();
        getClientStatus();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
        if ($stateParams.taskId) {
            if ($stateParams.taskStatus == 'close') {
                $scope.isClosedTasks = false;
            } else {
                $scope.isClosedTasks = true;
            }
        }
    };
    UserService.adjustStickyHeaderWindowResize();

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

StatusListController.$inject = ['$scope', '$state', '$compile', '$timeout',
    '$rootScope', '$stateParams', 'UserService', 'ClusterService', '$modal',
    'ModalService', 'DateRangeService', 'TaskService', 'WorkflowsService',
    'OrdersService', '$ioAlert', 'FormService', 'StatusService'];
function StatusListController ($scope, $state, $compile, $timeout, $rs,
                               $stateParams, UserService, ClusterService, $modal, ModalService,
                               DateRangeService, TaskService, WorkflowsService, OrdersService,
                               $ioAlert, FormService, StatusService) {
    $scope.statuses = null;
    $scope.statusTypes = null;

    $scope.managementTools = function() {
        $state.go('managementTools');
    }

    $scope.addOrEditStatus = function(status) {
        $scope.isNew = (status == null);

        let modalObj = $modal.open(
            ModalService.returnModalType('createCustomStatus', {
                data: {
                    status: status,
                    statusTypes: $scope.statusTypes,
                }
            })
        );

        modalObj.result.then(function(formObj) {
            formObj.active = formObj.active ? 1 : 0;

            if ($scope.isNew) {
                StatusService.addCustomStatus(formObj).then(function(success) {
                    let newStatus = success.status;
                    const statusType = _.find($scope.statusTypes, {id: newStatus.type_id});
                    newStatus.type_name = statusType ? statusType.name : '';
                    $scope.statuses.push(newStatus);
                    $ioAlert.show('', 'Added new status successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error adding status!', error, 'error');
                    console.log("error saving status");
                });
            } else {
                formObj.id = status.id;

                StatusService.updateCustomStatus(formObj).then(function(success) {
                    let newStatus = success.status;
                    const statusType = _.find($scope.statusTypes, {id: newStatus.type_id});
                    newStatus.type_name = statusType ? statusType.name : '';
                    const foundIndex = $scope.statuses.findIndex(x => x.id == success.status.id);
                    $scope.statuses[foundIndex] = newStatus;
                    $ioAlert.show('', 'Updated status successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error updating status!', error, 'error');
                    console.log("error updating status");
                });
            }
        }, function() {})
    };

    const init = function() {
        ClusterService.initCluster($rs.userRole).then(function() {
            const type_id = -1;
            const custom = -1;
            const active = -1;

            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching Admin Tools";

            StatusService.getAllStatuses(type_id, custom, active).then(function(success) {
                $scope.statuses = success.statuses;
                $rs.loadingInProgress = false;
            }, function(error) {
                $ioAlert.show('Error loading statuses!', error, 'error');
                console.log("error loading statuses");
                $rs.loadingInProgress = false;
            });
            StatusService.getAllStatusTypes().then(function(success) {
                $scope.statusTypes = success.statusTypes;
            }, function(error) {
                console.log("error loading status types");
            });
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
        UserService.adjustStickyHeader();
    };

    UserService.adjustStickyHeaderWindowResize();

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}